import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import { AuthContextProvider } from "./lib/authContext";
import { ToastContainer } from "react-toastify";

import "./App.css";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <BrowserRouter>
      <AuthContextProvider>
        <ToastContainer hideProgressBar={true} autoClose={3000} />
        <AppRoutes />
      </AuthContextProvider>
    </BrowserRouter>
  );
}

export default App;
